import {unref} from "vue";
import {UploadChangeParam} from "ant-design-vue";
import GoingUtils from "@/utils/goingUtils";
import {delFileByBusId} from "@/components/fileCtl/api/file";
import {loadFileList} from "@/components/xmFileComCtl/server/fileServer";
import {getBase64} from "xmgoing-utils";

interface IUploadEvent {
  uploadAction?: any;
  base64?: boolean;
  multiple: any;
  emit: any;
  userFileList?: any;
  businessId: any;
  flushList?: any;
}

export function useFileUploadEventHooks({
                                          uploadAction,
                                          base64 = false,
                                          multiple,
                                          emit,
                                          userFileList,
                                          businessId,
                                          flushList = function () {
                                          }
                                        }: IUploadEvent) {

  const beforeUpload = async function () {
    emit("beforeUpload", {});
    userFileList.value=[];
    if (unref(multiple) === false) {
      await delFileByBusId(unref(businessId)).then(() => {
      });
    }
    //如果不是系统上传api则就无法删除操作 则直接设置为空
    if ((unref(uploadAction) + '').indexOf("/attachment/upload") < 0 && unref(multiple) === false) {
      return;
    }
  };

  /**
   * 上传成功后的状态
   * @param info
   */
  const handleChange = async (info: UploadChangeParam) => {
    if (info.file.status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === "done") {
      if((info.file.response.code+'')!=='200'){
        GoingUtils.showErrorMessage(info.file.response.msg+"！");
        return;
      }
      if (info.file.response && Array.isArray(info.file.response.data) && info.file.response.data[0]) {
        emit('update:value', info.file.response.data[0].id);
        //如果是需要base64 格式的信息
        if (base64) {
          getBase64(
            `/api/pe-attachment/attachment/showImg/` + info.file.response.data[0].id
          ).then((res) => {
            emit('update:fileUrl', res);
          });
        } else {
          emit('update:fileUrl', `/api/pe-attachment/attachment/showImg/` + info.file.response.data[0].id);
        }
      }
      emit('update:busId', unref(businessId));
      if (info.file.response && info.file.response.data) {
        emit('done', {businessId: unref(businessId), records: info.file.response.data});
      }
      flushList && flushList();
    } else if (info.file.status === "error") {
      emit('error', {info});
      GoingUtils.showMessage("上传失败！");
    }
  };


  return {
    beforeUpload,
    handleChange
  }
}
